import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import RatingMui from '@mui/material/Rating';

export const Rating = styled(RatingMui)(({ theme }) => ({
  '& .MuiRating-icon': {
    color: theme.palette.brand.darkGreen
  },
  '& .MuiRating-iconHover': {
    color: theme.palette.brand.darkGreen
  }
}));

export const ModalWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutrals.beige1,
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '568px',
  maxHeight: '80vh',
  overflowY: 'auto',
  top: '50%',
  borderRadius: '15px',
  outline: 'none',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    transform: 'none',
    top: 'initial',
    bottom: 0,
    left: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  }
}));

export const ModalContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: '48px 60px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    padding: '48px 30px'
  }
}));

export const StarsRow = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  gap: '2px',
  margin: '24px 0'
});
